import { render, staticRenderFns } from "./print-test.vue?vue&type=template&id=2bb642d7&"
import script from "./print-test.vue?vue&type=script&lang=js&"
export * from "./print-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports